/**
 * Mailchimp marketing opt-in checkbox name sent with public forms.
 * Keep equal to backend `constants/mailchimpFormConsent.js` and embed-form.js.
 */
export const MAILCHIMP_MARKETING_CONSENT_FIELD = 'idotoo_mailchimp_marketing_consent';

/** Default supplier-facing consent wording (supplier can customise). Mirrors backend default. */
export const DEFAULT_MAILCHIMP_CONSENT_MESSAGE =
  'I would like occasional emails with wedding-related news and offers from this supplier. I understand I can unsubscribe at any time.';
